import { render, staticRenderFns } from "./CategoryProductMobile.vue?vue&type=template&id=155373e6&scoped=true"
import script from "./CategoryProductMobile.vue?vue&type=script&lang=js"
export * from "./CategoryProductMobile.vue?vue&type=script&lang=js"
import style0 from "./CategoryProductMobile.vue?vue&type=style&index=0&id=155373e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155373e6",
  null
  
)

export default component.exports